import { StatusBar, StatusBarStyle } from 'expo-status-bar'
import React, { useState } from 'react'
import { ActivityIndicator, View } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'

import { Text } from '../../components'
import { CommonButton } from '../../components/commonButton/CommonButton'
import { translate } from '../../i18n/translate'
import { useStore } from '../../models'
import { events } from '../../models/analytics/analytics-events'
import { color, fontFamily } from '../../theme'
import { startStyles } from './styles'
import { useRouter } from 'expo-router'

export const LiveEventScreen = () => {
  const router = useRouter()

  const store = useStore()
  const [isLoading, setIsLoading] = useState(false)

  React.useEffect(() => {
    setIsLoading(true)
    const callApi = async () => {
      // TODO: user should be already on state when this screen is opened
      // Probably will get fixed once we follow the right approach for navigation and auth https://reactnavigation.org/docs/auth-flow/?config=dynamic
      await store.session.fetchMe()
      const response = await store.session.getUserInfo()

      if (response?.isUserNew) {
        store.session.setIsLoggedInFirstTime(false)
        router.navigate('/(root)/(tabs)')
      }
      setIsLoading(false)
    }
    callApi()
  }, [store.session, router])

  const onNext = () => {
    store.analytics.setEvent(events.onboarding.event_form_completed, {
      liveEvent: 'no',
      segmentUserId: store.analytics.getSegmentUserID(),
      segmentIdentity: store.analytics.getUserIdentify()
    })
    if (store.session?.user?._id) {
      store.analytics.setUserIdentify(store.session?.user?._id, {
        eventAttendee: 'no'
      })
    }
    router.navigate('/onboarding/name')
  }

  const goToLive = () => {
    store.analytics.setEvent(events.onboarding.event_form_completed, {
      liveEvent: 'yes',
      segmentUserId: store.analytics.getSegmentUserID(),
      segmentIdentity: store.analytics.getUserIdentify()
    })
    if (store.session?.user?._id) {
      store.analytics.setUserIdentify(store.session?.user?._id, {
        eventAttendee: 'yes'
      })
    }
    router.navigate('/live-event-name')
  }

  if (isLoading) {
    return (
      <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center', backgroundColor: '#F6F2E9' }}>
        <StatusBar animated={true} style={'dark' as StatusBarStyle} hidden={false} />
        <ActivityIndicator size="small" color="#7B043D" />
      </View>
    )
  }

  return (
    <SafeAreaView style={[startStyles.startContainer, { backgroundColor: '#F6F2E9' }]}>
      <StatusBar animated={true} style={'dark' as StatusBarStyle} hidden={false} />
      <View style={startStyles.eventContainer}>
        <View>
          <Text style={[startStyles.eventQuestionText, { marginTop: 110 }]}>
            {translate('liveEventScreen.question1')}
          </Text>
          <Text style={[startStyles.eventQuestionText, { fontFamily: fontFamily.FeatureDeckBold }]}>
            {translate('liveEventScreen.question2')}
            <Text style={startStyles.eventQuestionText}>{translate('liveEventScreen.question3')}</Text>
          </Text>
        </View>
        <View>
          <CommonButton name={translate('liveEventScreen.noImNot')} onPress={onNext} />
          <CommonButton
            name={translate('liveEventScreen.yesImLive')}
            onPress={goToLive}
            btnStyle={startStyles.button2}
            textStyle={{ color: color.smokyBlack }}
          />
        </View>
      </View>
    </SafeAreaView>
  )
}
